import api from './api';

export const userService = {
  changePassword: async ({ currentPassword, newPassword }) => {
    const response = await api.put('/users/me/password', { currentPassword, newPassword });
    return response.data;
  },

  updateTutorialStatus: async (status) => {
    const response = await api.put('/users/me/tutorial', { status });
    return response.data;
  },

  markWhatsNewSeen: async (version) => {
    const response = await api.put('/users/me/whats-new', { version });
    return response.data;
  },
};
